import { render } from "./Menu.vue?vue&type=template&id=9bcc0be2"
import script from "./Menu.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Volumes/ext/winglet/license/grm/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9bcc0be2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9bcc0be2', __exports__)) {
    api.reload('9bcc0be2', __exports__)
  }
  
  module.hot.accept("./Menu.vue?vue&type=template&id=9bcc0be2", () => {
    api.rerender('9bcc0be2', render)
  })

}


export default __exports__